import { useEffect, useState } from 'preact/hooks'
import { useOption } from '../hooks/useOption'
import { RANGE_INDICATOR } from './FilterUtils'

export function FilterInputSlider({ filter, onFilter }) {
  const activeFilters = useOption('filters', {
    defaultValue: new Set()
  })

  function handleSelect(value) {
    const filters = [...activeFilters].filter((item) => item.includes(filter.field))
    if (value) filters.push(`${filter.field}:${value.min}${RANGE_INDICATOR}${value.max}`)
    onFilter(filters.join(','))
  }

  return (
    <div class="flex flex-col gap-2">
      <div class="mx-2 flex items-center justify-between">
        <p>Min ${filter.range[0]}</p>
        <p>Max ${filter.range[1]}</p>
      </div>
      <RangeSlider min={filter.range[0]} max={filter.range[1]} step={filter.step} onChange={handleSelect} />
    </div>
  )
}

// Credit here:
// https://benhoneywill.com/building-a-range-slider-component-in-react/

const RangeSlider = ({ min, max, value, step, onChange }) => {
  const [minValue, setMinValue] = useState(value ? value.min : min)
  const [maxValue, setMaxValue] = useState(value ? value.max : max)

  useEffect(() => {
    if (value) {
      setMinValue(value.min)
      setMaxValue(value.max)
    }
  }, [value])

  const handleMinChange = (event) => {
    const newMinVal = Math.min(event.target.value, maxValue - step)
    if (!value) setMinValue(newMinVal)
    onChange({ min: newMinVal, max: maxValue })
  }

  const handleMaxChange = (event) => {
    const newMaxVal = Math.max(event.target.value, minValue + step)
    if (!value) setMaxValue(newMaxVal)
    onChange({ min: minValue, max: newMaxVal })
  }

  const minPos = ((minValue - min) / (max - min)) * 100
  const maxPos = ((maxValue - min) / (max - min)) * 100

  return (
    <div class="relative mx-2 my-1 flex h-2 items-center">
      <div class="absolute -my-1 h-2 w-full">
        <input
          class="thumb-hide pointer-events-none absolute top-1/2 z-20 h-full w-full -translate-y-1/2 appearance-none p-0 opacity-0"
          type="range"
          value={minValue}
          min={min}
          max={max}
          step={step}
          onChange={handleMinChange}
        />
        <input
          class="thumb-hide pointer-events-none absolute top-1/2 z-20 h-full w-full -translate-y-1/2 appearance-none p-0 opacity-0"
          type="range"
          value={maxValue}
          min={min}
          max={max}
          step={step}
          onChange={handleMaxChange}
        />
      </div>
      <div class="absolute h-2 w-full">
        <div
          class="absolute top-1/2 z-10 -mr-2 h-2 w-2 -translate-y-1/2 rounded-full bg-primary-black"
          style={{ left: `${minPos}%` }}
        />
        <div class="absolute top-1/2 h-1 w-full -translate-y-1/2 rounded-full bg-primary-grey">
          <div class="absolute h-full bg-primary-black" style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }} />
        </div>
        <div
          class="absolute top-1/2 z-10 -ml-2 h-2 w-2 -translate-y-1/2 rounded-full bg-primary-black"
          style={{ left: `${maxPos}%` }}
        />
      </div>
    </div>
  )
}
